export default "__VITE_ASSET__7e516a40__"